import { useEffect, useState } from 'react';
import { MdOutlineShoppingBasket } from 'react-icons/md';
import { AiOutlineClockCircle } from 'react-icons/ai';
import { BsExclamationTriangle } from 'react-icons/bs';

import MiniStatistics from 'components/card/MiniStatistics';
import { getSupplierPurchaseStats } from 'interfaces/supplier';

type Stats = {
    purchasesCount: number;
    overallAverageDelayDays: number | null;
    openDisputesCount: number;
};

const SupplierStats = (props: { id?: string }) => {
    const { id } = props;
    const [stats, setStats] = useState<Stats | null>(null);

    const fetchStats = async () => {
        if (!id) return;
        const res = await getSupplierPurchaseStats(id);
        if (res) setStats(res);
    };

    useEffect(() => {
        fetchStats();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    return (
        <div className="col-span-12 grid h-full w-full grid-cols-1 gap-3 sm:gap-5 sm:grid-cols-3">
            <MiniStatistics
                name="Commandes"
                value={stats ? stats.purchasesCount : '-'}
                icon={<MdOutlineShoppingBasket color="#0260CB" />}
                iconBg="bg-lightPrimary"
            />
            <MiniStatistics
                name="Délai moyen de livraison"
                value={stats && stats.overallAverageDelayDays !== null ? `${stats.overallAverageDelayDays} j` : '-'}
                icon={<AiOutlineClockCircle color="#0260CB" />}
                iconBg="bg-lightPrimary"
            />
            <MiniStatistics
                name="Litiges ouverts"
                value={stats ? stats.openDisputesCount : '-'}
                icon={<BsExclamationTriangle color="#0260CB" />}
                iconBg="bg-lightPrimary"
            />
        </div>
    );
};

export default SupplierStats;
